import { render, staticRenderFns } from "./SaleReportHeaderSg.vue?vue&type=template&id=aea6401a"
import script from "./SaleReportHeaderSg.vue?vue&type=script&lang=js"
export * from "./SaleReportHeaderSg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports